import { css } from "@linaria/core";
import { colors, spacings } from "@ui/Theme";

export const editorSection = css`
  padding: 0 ${spacings.m};
  > * + * {
    margin-top: ${spacings.m};
    width: 100%;
  }
`;

export const editorSectionTitle = css`
  color: ${colors.carbon900};
`;

export const editorSectionSeparator = css`
  background-color: ${colors.titanium200};
  height: 1px;
  margin: ${spacings.m} 0;
  width: 100%;
`;
